<section class="m-4 p-4">
  <h2 class="m-0">
    <span translate>Add</span>
    {{
      isEditMode === false
        ? ("Mission/Vision" | translatepipe)
        : data.rowData?.content_type === ("Mission" | translatepipe)
          ? ("Mission" | translatepipe)
          : ("Vision" | translatepipe)
    }}
  </h2>
  <mat-divider class="my-3"></mat-divider>

  <div class="d-flex flex-column flex-md-row align-items-start">
    <!-- Left Form Section -->
    <form [formGroup]="missionVissionForm" class="flex-grow-1 pe-md-4">
      <div class="mb-3">
        <div class="form-group">
          <app-question
            [question]="questions[0]"
            [form]="missionVissionForm"
            class="mission-vision-textarea"
          ></app-question>
          <div [class.disabled]="isEditMode">
            <app-question
              [question]="questions[1]"
              [form]="missionVissionForm"
              class="mission-vision-textarea"
            ></app-question>
          </div>
        </div>
      </div>
    </form>

    <!-- Right Image Upload Section -->
    <div class="selected-image-container ms-md-4 mt-3 mt-md-0">
      <div class="upload-box position-relative" (click)="fileInput.click()">
        <input
          #fileInput
          hidden
          type="file"
          (change)="imageInputChange($event)"
          accept="image/*"
        />

        <!-- The image that shows preview or fallback -->
        <img
          [src]="
            selectedImageUrl ||
            '../../../../../../assets/images/bulkupload_logo.svg'
          "
          alt="Mission / Vision Image"
          class="img-fluid selected-image w-100 h-100 object-fit-contain"
        />
      </div>
    </div>
  </div>

  <mat-dialog-actions align="center" class="bg-white pt-4">
    <div class="d-flex gap-3">
      <button
        translate
        mat-stroked-button
        class="cancel_button"
        (click)="closeDialog(false)"
      >
        Cancel
      </button>
      <button
        mat-raised-button
        color="primary"
        [disabled]="missionVissionForm.invalid"
        type="submit"
        (click)="onSubmit()"
      >
        {{
          isEditMode === false
            ? ("Submit" | translatepipe)
            : ("Update" | translatepipe)
        }}
      </button>
    </div>
  </mat-dialog-actions>
</section>
